export const BEM_BLOCK_NAME = 'app_header';
export const RELEASE_NOTES_OPTION_ID = 'releaseNotes';
